import { siteInfo } from '../../data/mock';

export const ServiceFooter = () => (
<footer className="bg-gray-950 border-t border-red-900/40 py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-gray-400">
            © 2025 Maître Diamma - Marabout Africain Guadeloupe - Retour Affectif Rapide
          </p>
          <p data-testid="service-footer-contact-number" className="text-sm text-gray-500 mt-2">
            Téléphone: {siteInfo.phoneDisplay} • WhatsApp: {siteInfo.phoneDisplay}
          </p>
        </div>
      </footer>
);
